import { Box, Card } from '@mui/material';
import AdminAddDashboardAreaConfirmDeleteModal from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboardsList/AdminAddDashboardAreaConfirmDeleteModal/AdminAddDashboardAreaConfirmDeleteModal';
import AdminAddDashboardAreaModal from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboardsList/AdminAddDashboardAreaModal/AdminAddDashboardAreaModal';
import AdminAddDashboardsListItem from '@src/main/ui/components/AdminAddDashboards/common/AdminAddDashboardsList/AdminAddDashboardListItem/AdminAddDashboardsListItem';
import List from '@src/main/ui/components/common/List/List';
import FabButton from '@src/main/ui/components/common/buttons/FabButton';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AdminAddDashboardsList.module.scss';

interface Props {
  items: { id: string; name: string }[];
  actions: {
    add: boolean;
    edit: boolean;
    delete: boolean;
  };
  navigateURL: (id: string) => string;
}

const AdminAddDashboardsAreas: FC<Props> = ({ items, actions, navigateURL }) => {
  const navigate = useNavigate();
  const [modal, setModal] = useState<{
    open: boolean;
    name: string;
    id: string | null;
  }>({
    open: false,
    name: '',
    id: null,
  });
  const [modalConfirmDelete, setModalConfirmDelete] = useState<{
    open: boolean;
    id: string | null;
    name: string;
  }>({
    open: false,
    id: null,
    name: '',
  });

  return (
    <Box className={styles.container}>
      <Card className={styles.container__card}>
        <List>
          {items?.map((item) => (
            <AdminAddDashboardsListItem
              key={item.id}
              item={item}
              actions={actions}
              onClick={() => navigate(navigateURL(item.id))}
              onClickEdit={(params) => setModal(params)}
              onClickDelete={(params) => setModalConfirmDelete(params)}
            />
          ))}
        </List>
      </Card>
      {actions.add && (
        <FabButton
          onClick={() =>
            setModal({
              open: true,
              name: '',
              id: null,
            })
          }
          icon="add"
        />
      )}
      {modal.open && (
        <AdminAddDashboardAreaModal
          onClose={() =>
            setModal({
              open: false,
              name: '',
              id: null,
            })
          }
          id={modal.id}
          name={modal.name}
        />
      )}
      {modalConfirmDelete.open && modalConfirmDelete.id && (
        <AdminAddDashboardAreaConfirmDeleteModal
          onClose={() =>
            setModalConfirmDelete({
              open: false,
              id: null,
              name: '',
            })
          }
          id={modalConfirmDelete.id}
          name={modalConfirmDelete.name}
        />
      )}
    </Box>
  );
};
export default AdminAddDashboardsAreas;
